import { render, staticRenderFns } from "./FaceMoveModal.vue?vue&type=template&id=1bfd22e7&scoped=true"
import script from "./FaceMoveModal.vue?vue&type=script&lang=ts"
export * from "./FaceMoveModal.vue?vue&type=script&lang=ts"
import style0 from "./FaceMoveModal.vue?vue&type=style&index=0&id=1bfd22e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfd22e7",
  null
  
)

export default component.exports